const TabPane = () => null;
if (process.env.NODE_ENV !== 'production') {
    TabPane.displayName = 'DeprecatedTabPane';
}
export default TabPane;
